import React, { Component} from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import * as actions from '../actions';
import Auth from './Auth';
import JqxLoader from '../widgets/jqwidgets-react/react_jqxloader';
import AdminPanel from './AdminPanel';
import Error from '../components/Error';

class App extends Component {
    constructor(props){
        super(props);
        this.state={
            isLoaderVisible: false
        };
    }

    hideLoader(){
        this.loaderTimer = null;
        if(this.state.isLoaderVisible){
            this.refs.ordersLoader.close();
            this.setState({isLoaderVisible: false});
        }
    }

    showLoader(){
        this.loaderTimer = setTimeout(() => {
            if(this.loaderTimer) {
                if (!this.state.isLoaderVisible) {
                    this.refs.ordersLoader.open();
                    this.setState({isLoaderVisible: true});
                    this.loaderTimer = null;
                }
            }
            }, 500);
    }

    render() {
        return (
            <div>
                <Helmet
                    defaultTitle="Панель администратора"
                    titleTemplate="%s - Панель администратора"
                    htmlAttributes={{"lang": "ru"}}/>
                <div ref={'loaderContainer'} style={{zIndex: 101, display: this.state.isLoaderVisible ? 'block' : 'none'}}>
                <JqxLoader
                    ref={'ordersLoader'}
                    width={100}
                    height={60}
                    imagePosition={'center'}
                    text={'Загрузка...'}
                    isModal={true}
                />
                </div>
                {this.props.error ? <Error error={this.props.error} clearError={this.props.clearError}/> : false}
                {this.props.authState
                    ?
                    <AdminPanel
                        showLoader={this.showLoader.bind(this)}
                        hideLoader={this.hideLoader.bind(this)}/>
                    :
                    <Auth
                        showLoader={this.showLoader.bind(this)}
                        hideLoader={this.hideLoader.bind(this)}
                        clearError={this.props.clearError}
                        context={this}/>
                }
            </div>
        )
    }
}


function mapDispatchToProps(dispatch) {
    return {
        clearError: () => {
            dispatch(actions.clearError());
        },
        setError: (error) => {
            dispatch(actions.setError(error));
        }
    };
}

function mapStateToProps(state) {
    return {
        authState: state.adminPanelReducer.authState,
        error: state.adminPanelReducer.error
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js